var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }
  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }
    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }
    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }
    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};
var __generator = this && this.__generator || function (thisArg, body) {
  var _ = {
      label: 0,
      sent: function () {
        if (t[0] & 1) throw t[1];
        return t[1];
      },
      trys: [],
      ops: []
    },
    f,
    y,
    t,
    g;
  return g = {
    next: verb(0),
    "throw": verb(1),
    "return": verb(2)
  }, typeof Symbol === "function" && (g[Symbol.iterator] = function () {
    return this;
  }), g;
  function verb(n) {
    return function (v) {
      return step([n, v]);
    };
  }
  function step(op) {
    if (f) throw new TypeError("Generator is already executing.");
    while (g && (g = 0, op[0] && (_ = 0)), _) try {
      if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
      if (y = 0, t) op = [op[0] & 2, t.value];
      switch (op[0]) {
        case 0:
        case 1:
          t = op;
          break;
        case 4:
          _.label++;
          return {
            value: op[1],
            done: false
          };
        case 5:
          _.label++;
          y = op[1];
          op = [0];
          continue;
        case 7:
          op = _.ops.pop();
          _.trys.pop();
          continue;
        default:
          if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
            _ = 0;
            continue;
          }
          if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
            _.label = op[1];
            break;
          }
          if (op[0] === 6 && _.label < t[1]) {
            _.label = t[1];
            t = op;
            break;
          }
          if (t && _.label < t[2]) {
            _.label = t[2];
            _.ops.push(op);
            break;
          }
          if (t[2]) _.ops.pop();
          _.trys.pop();
          continue;
      }
      op = body.call(thisArg, _);
    } catch (e) {
      op = [6, e];
      y = 0;
    } finally {
      f = t = 0;
    }
    if (op[0] & 5) throw op[1];
    return {
      value: op[0] ? op[1] : void 0,
      done: true
    };
  }
};
export var loadBrandData = function (brand) {
  return __awaiter(void 0, void 0, void 0, function () {
    var brandHash, brandMap, brandIndex;
    return __generator(this, function (_a) {
      switch (_a.label) {
        case 0:
          brandHash = function (brand) {
            if (!brand) {
              return '';
            }
            var code = Array.from(brand).map(function (c) {
              return c.charCodeAt(0);
            }).join('');
            return "brand-" + code;
          };
          brandMap = {
            "brand-9797110122": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-9797110122" */"./aanz")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-9797114112": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-9797114112" */"./aarp")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-979711611497118101108108101114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-979711611497118101108108101114" */"./aatraveller")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-9798114105116101108": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-9798114105116101108" */"./abritel")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-979999111114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-979999111114" */"./accor")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-9710511499971109710097": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-9710511499971109710097" */"./aircanada")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-97105114110122": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-97105114110122" */"./airnz")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-97108971151079797105114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-97108971151079797105114" */"./alaskaair")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-989710410597": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-989710410597" */"./bahia")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-989711499101108111": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-989711499101108111" */"./barcelo")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-98105108116": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-98105108116" */"./bilt")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-98110115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-98110115" */"./bns")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-9811111110797989799104": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-9811111110797989799104" */"./bookabach")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-98111111107101116121": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-98111111107101116121" */"./bookety")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-999711411410111011697108115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-999711411410111011697108115" */"./carrentals")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-999711610497121112979910510210599": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-999711610497121112979910510210599" */"./cathaypacific")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-9910410197112104111116101108115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-9910410197112104111116101108115" */"./cheaphotels")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-9910410197112114111111109115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-9910410197112114111111109115" */"./cheaprooms")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-991041019711211610599107101116115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-991041019711211610599107101116115" */"./cheaptickets")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10010110297117108116": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10010110297117108116" */"./default")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1001011029711710811695111108100": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1001011029711710811695111108100" */"./default_old")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-100101102971171081161159549100108": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-100101102971171081161159549100108" */"./defaults_1dl")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10010110811697": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10010110811697" */"./delta")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10198111111107101114115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10198111111107101114115" */"./ebookers")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10110011410197109115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10110011410197109115" */"./edreams")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011039599111110115111108101": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011039599111110115111108101" */"./eg_console")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011039511297114116110101114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011039511297114116110101114" */"./eg_partner")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011031001159510011199115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011031001159510011199115" */"./egds_docs")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011031011109910597": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011031011109910597" */"./egencia")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011121159510010110297117108116115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011121159510010110297117108116115" */"./eps_defaults")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011121159511610110911210897116101": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011121159511610110911210897116101" */"./eps_template")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-101112115951211111171149811497110100": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-101112115951211111171149811497110100" */"./eps_yourbrand")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-101115999711210597": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-101115999711210597" */"./escapia")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011161159511297114116110101114959897115101": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011161159511297114116110101114959897115101" */"./ets_partner_base")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-101116115951129711411611010111495991111101021051039549": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-101116115951129711411611010111495991111101021051039549" */"./ets_partner_config_1")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-101116115951129711411611010111495991111101021051039550": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-101116115951129711411611010111495991111101021051039550" */"./ets_partner_config_2")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011209910110810810111099101103114112": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011209910110810810111099101103114112" */"./excellencegrp")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10112011210110010597": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10112011210110010597" */"./expedia")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011201121011001059795103114111117112": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011201121011001059795103114111117112" */"./expedia_group")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1011201121011001059795114101102114101115104": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1011201121011001059795114101102114101115104" */"./expedia_refresh")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-102101114114105115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-102101114114105115" */"./ferris")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-102101119111100105114101107116": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-102101119111100105114101107116" */"./fewodirekt")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-102108105103104116115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-102108105103104116115" */"./flights")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-104971199710510597110": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-104971199710510597110" */"./hawaiian")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-104105108116111110": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-104105108116111110" */"./hilton")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1041111091019711997121": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1041111091019711997121" */"./homeaway")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-104111116101108108101114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-104111116101108108101114" */"./hoteller")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-104111116101108115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-104111116101108115" */"./hotels")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-104111116101108115951161011151169550485053": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-104111116101108115951161011151169550485053" */"./hotels_test_2025")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-104111116101108115116104101991111109910111411611010112011711599111109": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-104111116101108115116104101991111109910111411611010112011711599111109" */"./hotelstheconcertnexuscom")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10411111610110811511610410110411111610110811010112011711599111109": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10411111610110811511610410110411111610110811010112011711599111109" */"./hotelsthehotelnexuscom")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10411111610110811511610410111410197108112108979910111599111109": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10411111610110811511610410111410197108112108979910111599111109" */"./hotelstherealplacescom")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-104111116119105114101": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-104111116119105114101" */"./hotwire")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1059810111411111511697114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1059810111411111511697114" */"./iberostar")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10610111611511697114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10610111611511697114" */"./jetstar")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10897991111081019999105111110": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10897991111081019999105111110" */"./lacoleccion")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10897115116109105110117116101": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10897115116109105110117116101" */"./lastminute")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-10997114114105111116116": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-10997114114105111116116" */"./marriott")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-109971151161011149997114100": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-109971151161011149997114100" */"./mastercard")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-109103109": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-109103109" */"./mgm")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-109114106101116": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-109114106101116" */"./mrjet")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-111112111100111": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-111112111100111" */"./opodo")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11111498105116122": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11111498105116122" */"./orbitz")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-112971141161101011149910111011611497108": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-112971141161101011149910111011611497108" */"./partnercentral")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11297116116105115111110103114111117112": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11297116116105115111110103114111117112" */"./pattisongroup")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11210410510810511211210511010197105114108105110101115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11210410510810511211210511010197105114108105110101115" */"./philippineairlines")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1149899": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1149899" */"./rbc")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-114105117": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-114105117" */"./riu")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-115971101009811112095116104101109101": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-115971101009811112095116104101109101" */"./sandbox_theme")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11597115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11597115" */"./sas")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11511697121122": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11511697121122" */"./stayz")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-115119111111112": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-115119111111112" */"./swoop")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1169797112": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1169797112" */"./taap")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-116100": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-116100" */"./td")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11611497118101108105991011089711010097105114": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11611497118101108105991011089711010097105114" */"./travelicelandair")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11611497118101108108105110107": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11611497118101108108105110107" */"./travellink")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1161149711810110811199105116121": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1161149711810110811199105116121" */"./travelocity")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11611497118101108115111102105": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11611497118101108115111102105" */"./travelsofi")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-116114971181011081199710810997114116112108117115": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-116114971181011081199710810997114116112108117115" */"./travelwalmartplus")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1171001159510010110297117108116": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1171001159510010110297117108116" */"./uds_default")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-117110105116101100": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-117110105116101100" */"./united")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1181111219710310111495110101120116": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1181111219710310111495110101120116" */"./voyager_next")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-11811498111": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-11811498111" */"./vrbo")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-1191011081081151029711410311111611497118101108": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-1191011081081151029711410311111611497118101108" */"./wellsfargotravel")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            },
            "brand-119111116105102": function () {
              return __awaiter(void 0, void 0, void 0, function () {
                return __generator(this, function (_a) {
                  switch (_a.label) {
                    case 0:
                      return [4 /*yield*/, import(/* webpackChunkName: "brand-119111116105102" */"./wotif")];
                    case 1:
                      return [2 /*return*/, _a.sent()];
                  }
                });
              });
            }
          };
          brandIndex = brandHash(brand);
          if (!(brandIndex in brandMap)) return [3 /*break*/, 2];
          return [4 /*yield*/, brandMap[brandIndex]()];
        case 1:
          return [2 /*return*/, _a.sent()];
        case 2:
          return [4 /*yield*/, brandMap['brand-1171001159510010110297117108116']()];
        case 3:
          return [2 /*return*/, _a.sent()];
      }
    });
  });
};